import { useMemo } from 'react';
import { toast } from 'react-toastify';
import useSWR from 'swr';
import api from '../services/api';
import { PROCEDIMENTOS_SWR_KEY } from './clearCache';

const EMPTY_PROCEDIMENTOS = [];
const EMPTY_OPCOES = [];

const fetchProcedimentos = async () => {
  const result = await api.get('procedimentos');
  return result.data.procedimentos || EMPTY_PROCEDIMENTOS;
};

const useProcedimentos = () => {
  const { data: procedimentos = EMPTY_PROCEDIMENTOS } = useSWR(
    PROCEDIMENTOS_SWR_KEY,
    fetchProcedimentos,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
      onError: error => {
        toast.error(
          error?.response?.data?.error || 'Erro ao carregar procedimentos!'
        );
      },
    }
  );

  const opcoesProcedimento = useMemo(() => {
    if (!procedimentos.length) return EMPTY_OPCOES;
    return procedimentos.map(p => ({
      value: p.CODPROCEDI,
      label: p.DESCPROCEDI,
    }));
  }, [procedimentos]);

  return { procedimentos, opcoesProcedimento };
};

export default useProcedimentos;
